import { Navigate } from 'react-router-dom';
import { LoadingContent } from '@/components/Loading';
import { useAuth } from '@/context/AuthContext';
import { getStoredUser, isClubUser } from '@/services/authSession';
import { ClubProvider } from './ClubContext';
import ClubShadcnShell from './layout/ClubShadcnShell';
import ClubUiProviders from './providers/ClubUiProviders';

export default function ClubProtected() {
    const { authenticated, authReady, user } = useAuth();
    const sessionUser = user || getStoredUser();

    if (!authReady || (authenticated && !sessionUser)) {
        return <LoadingContent />;
    }

    if (!authenticated) {
        return <Navigate to="/clube/login" replace />;
    }

    if (!isClubUser(sessionUser)) {
        return <Navigate to="/clube/login" replace />;
    }

    return (
        <ClubUiProviders rootId="club-root">
            <ClubProvider>
                <ClubShadcnShell />
            </ClubProvider>
        </ClubUiProviders>
    );
}
